import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../../redux/store/store";
import { selectCurrentUser } from "../../../redux/selectors/userSelector";
import NotificationModal from "../notification-modal/NotificationModal";
import {
  IdentityVerificationModal,
  SubscriptionModal,
} from "../../allComponents/AllComponents";
import { getUser } from "../../../redux/actions/userActions";
interface AccountVerificationModalProps {
  open: boolean;
  handleClose: () => void;
}

const AccountVerificationModal = (props: AccountVerificationModalProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector(selectCurrentUser);
  const { open, handleClose } = props;

  const [identityOpen, setIdentityOpen] = useState(false);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);
  const [notifyOpen, setNotifyOpen] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (userData?._id) {
      dispatch(getUser(userData?._id));
    }
  }, [dispatch, userData?._id]);

  useEffect(() => {
    if (open) {
      setIdentityOpen(true);
    }
  }, [open]);

  const closeAll = () => {
    setIdentityOpen(false);
    setNotifyOpen(false);
    setSubscriptionOpen(false);
    handleClose();
  };

  const handleVerified = () => {
    setIdentityOpen(false);
    setNotifyOpen(true);
    let sec = 5;
    setCountdown(sec);

    const timer = window.setInterval(() => {
      sec -= 1;
      setCountdown(sec);
      if (sec <= 0) {
        clearInterval(timer);
        setNotifyOpen(false);
        setSubscriptionOpen(true);
      }
    }, 1000);
  };

  const handleSubscriptionClose = () => {
    setSubscriptionOpen(false);
    closeAll();
    if (userData) navigate(`/user/${userData._id}`);
  };

  const handleIdentityClose = () => {
    setIdentityOpen(false);
    handleClose();
  };

  return (
    <>
      {identityOpen && userData?._id && (
        <IdentityVerificationModal
          open={identityOpen}
          userId={userData?._id!}
          onClose={handleIdentityClose}
          onVerified={handleVerified}
        />
      )}

      <NotificationModal
        open={notifyOpen}
        handleClose={() => setNotifyOpen(false)}
        title="Identity Verified"
      >
        <p>Your identity has been successfully verified.</p>
        <p>Redirecting to subscription in {countdown} seconds...</p>
      </NotificationModal>

      <SubscriptionModal
        open={subscriptionOpen}
        handleClose={handleSubscriptionClose}
      />
    </>
  );
};

AccountVerificationModal.propType = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default AccountVerificationModal;
